import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { login } from '../../services/auth'
import { me } from '../../services/user'
import { AUTH_TOKEN_KEY } from '../../app/contants'

export const loginUser = createAsyncThunk('user/login', async ({ username, password }, { rejectWithValue }) => {
  try {
    const response = await login(username, password)
    const data = response.data
    if (response.status === 200 && !!response.status) {
      localStorage.setItem(AUTH_TOKEN_KEY, data.jwt)
      return data
    } else {
      return rejectWithValue(data)
    }
  } catch (e) {
    return rejectWithValue(e.response.data)
  }
})

export const getUser = createAsyncThunk('user/me', async (payload, { rejectWithValue }) => {
  try {
    const response = await me()
    return response.data
  } catch (e) {
    return rejectWithValue(e.response.data)
  }
})

export const userSlice = createSlice({
  name: 'user',
  initialState: {
    user: {},
    isFetching: false,
    isSuccess: false,
    isError: false,
    errorMessage: '',
  },
  reducers: {
    clearState: (state) => {
      state.isError = false
      state.isSuccess = false
      state.isFetching = false

      return state
    },
  },
  extraReducers: {
    [loginUser.fulfilled]: (state, data) => {
      state.user = data.payload
      state.isFetching = false
      state.isSuccess = true
      return state
    },
    [loginUser.rejected]: (state, { payload }) => {
      state.isFetching = false
      state.isError = true
      state.errorMessage = payload.message
    },
    [loginUser.pending]: (state) => {
      state.isFetching = true
    },
    [getUser.fulfilled]: (state, data) => {
      state.user = data.payload
      state.isFetching = false
      state.isSuccess = true
      return state
    },
    [getUser.rejected]: (state, { payload }) => {
      state.isFetching = false
      state.isError = true
      state.errorMessage = payload.message
    },
    [getUser.pending]: (state) => {
      state.isFetching = true
    },
  },
})

export const { clearState } = userSlice.actions

export const userSelector = (state) => state.user
